import { Permission } from './permission.model';
import { matchRule } from '@core';

export class Profile {
    id: number;
    name: string;
    description: string;
    enable: boolean;
    permissions: Array<Permission> = [];
    note: string;
    image: string;


    constructor(profile: any) {
        if (!profile) {
            console.error("Profile isn't valorized");
            return;
        }
        this.id = profile.id;
        this.description = profile.description;
        if (!this.id) console.error("Profile not valid");

        this.enable = profile.enable === true;

        this.note = profile.note;
        this.image = profile.image;
        this.permissions = profile.permissions.map((permission) => new Permission(permission));
    }

    getPermissionByName(name: string) {
        return this.permissions.find((permission) => {
            return matchRule(permission.name, name);
        });
    }

    /**
    * @param name permission Name
    * @param operationName 3 possible values "read" / "write" / "all" read is default
    */
    isPermissionEnable(name: string, operationName: string = "read") {
        let foundedPermission = this.getPermissionByName(name);
        return foundedPermission ? foundedPermission.getValueForOperation(operationName) : false;
    }


}